import { Props as SelectProps } from "react-select";
import { SelectComponent } from "../SelectComponent";
import clsx from "clsx";

type Props = SelectProps & {
	noDefaultOption?: boolean;
	labelClassNames?: string;
};

export const defaultGender = { value: "", label: "Todos" };

export function GenderSelect({ noDefaultOption, labelClassNames, ...rest }: Props) {
	const options = [
		{ value: "", label: "Todos" },
		{ value: "M", label: "Masculino" },
		{ value: "F", label: "Feminino" },
		{ value: "O", label: "Outro" },
	];
	return (
		<>
			<label title="Gênero" htmlFor="gender" className={clsx(labelClassNames)}>
				Gênero
			</label>

			<SelectComponent
				className="fs-8 p-0"
				options={options}
				inputId="gender"
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhuma opção encontrada"}
				{...rest}
			/>
		</>
	);
}
